import { Reveal } from "@/components/Reveal";
import { Quote } from "lucide-react";

const REVIEWS = [
  "Very pleased with the work carried out today. Professional service and great aftercare.",
  "Quick, tidy and professional. My carpet looks brand new.",
  "Had my couch and rug cleaned and they turned out amazing. Look brand new and smell fresh.",
  "Hall and stair carpet came up looking like new. Fantastic job.",
  "Brilliant service, carpets are looking new. Would definitely use the guys again.",
];

const Card = ({ text }) => (
  <figure className="w-[300px] sm:w-[380px] shrink-0 rounded-3xl bg-white p-7 ring-1 ring-navy/10 shadow-sm">
    <Quote className="h-8 w-8 text-turquoise" />
    <blockquote className="mt-4 font-display text-lg leading-relaxed text-navy">
      “{text}”
    </blockquote>
    <div className="mt-5 flex items-center gap-1 text-turquoise">
      {[...Array(5)].map((_, i) => (
        <svg key={i} className="h-4 w-4 fill-current" viewBox="0 0 20 20">
          <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
        </svg>
      ))}
    </div>
  </figure>
);

export const Reviews = () => {
  const loop = [...REVIEWS, ...REVIEWS];
  return (
    <section id="reviews" data-testid="reviews-section" className="py-20 sm:py-28 overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-turquoise">
            Kind words
          </p>
          <h2 className="mt-3 font-display fluid-h2 font-semibold text-navy">
            What our{" "}
            <span className="italic text-turquoise">customers say</span>
          </h2>
        </Reveal>
      </div>

      <Reveal delay={0.1} className="mt-14">
        <div className="marquee-mask">
          <div className="marquee-track flex w-max gap-5 px-5">
            {loop.map((r, i) => (
              <Card key={i} text={r} />
            ))}
          </div>
        </div>
      </Reveal>
    </section>
  );
};
